document.addEventListener('DOMContentLoaded', function() {
  const pickers = document.querySelectorAll('swatches-variant-picker-component');
  pickers.forEach(function(picker) {
    const inputs = picker.querySelectorAll('input[type="radio"]');
    inputs.forEach(function(input) {
      input.checked = false;
    });
  });
});
